// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3isbL","validationTips":"StatementDescriptor_validationTips__1_0bB"};